//import gsap from 'gsap';
import lottie from 'lottie-web';
//import Splitting from 'splitting';
import inView from 'in-view'
import { smoothScroll } from './utils'
import LazyLoad from "vanilla-lazyload";
import Plyr from 'plyr'

const HTML = document.querySelector('html');

class App {
  constructor() {
    let linksAnchor = document.querySelectorAll('a[href*="#"]:not([href="#"])');
    // if( linksAnchor ) linksAnchor.forEach((el) => { el.addEventListener('click', smoothScroll) });

    const anim = document.querySelector('.anim');
    if (anim) {
      lottie.loadAnimation({
        container: anim, // the dom element that will contain the animation
        renderer: 'svg',
        loop: true,
        autoplay: true,
        path: `${settings.basepath}/static/json/data.json` // the path to the animation json
      });
    }

    // Lazyload
    this.lazyload = new LazyLoad({
      // eslint-disable-next-line camelcase
      elements_selector: '.js-lazy',
      threshold: 600,
      // eslint-disable-next-line camelcase
      callback_enter: ($el) => {
        if ($el.classList.contains('js-lazy-error-placeholder')) {
          $el.lazyLoadPlaceholder = $el.src;
        }

        const figure = $el.closest('figure');
        if (figure) figure.classList.add('img-is-loaded')

        if ($el.tagName == 'VIDEO' && $el.dataset.autoplay != undefined) {
          $el.play()
        }
      },
      callback_exit: ($el) => {
        // console.log($el);
      },
      // eslint-disable-next-line camelcase
      callback_error: ($el) => {
        if ($el.lazyLoadPlaceholder) {
          $el.src = $el.lazyLoadPlaceholder;
        }
      },
    });

    // Custom player
    const playersPlyr = document.querySelectorAll('.player-video')
    if (playersPlyr) {
      playersPlyr.forEach(player => {
        const p = new Plyr(player, {
          controls: ['play-large', 'play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen']
        })
      })
    }

    // popin trigger
    const triggerPopin = document.querySelectorAll('[data-popin]');
    if (triggerPopin) {
      triggerPopin.forEach(trigger => {
        const target = document.getElementById(trigger.dataset.popin);

        trigger.addEventListener('click', e => {
          e.preventDefault();
          if (target) {
            target.classList.toggle('show')

            // Autoplay video
            const video = target.querySelector('video');
            if (video) {
              video.play();
            }
          }
        })

        if (target) {
          // Init close
          ['.trigger-close', '.trigger-overlay'].forEach(selector => {
            const el = target.querySelector(selector)
            if (el) {
              el.addEventListener('click', closePopin)
            }
          })
        }
      })
      function closePopin(e) {
        e.preventDefault();
        const target = e.target.closest('.popin')
        target.classList.remove('show')

        // Autoplay video
        const video = target.querySelector('video');
        if (video) {
          video.pause();
        }
      }
    }

    // Video player
    const players = document.querySelectorAll('.video')
    if (players) {
      players.forEach(player => {
        const btn = document.createElement('a');
        btn.classList.add('btn-play');
        btn.innerHTML = '<span></span>'

        const video = player.querySelector('video')
        if (video) {
          player.append(btn)

          btn.addEventListener('click', e => {
            if (video.paused || video.ended)
              video.play();
            else
              video.pause();
          })

          video.addEventListener('play', () => player.classList.add('play'))
          video.addEventListener('pause', () => player.classList.remove('play'))
        }
      })
    }

    // In viewport
    inView.offset(window.innerHeight * .2);
    inView('.js-reveal:not(.is-visible)')
      .on('enter', function (elt) {
        elt.classList.add('is-visible');

        if (elt.tagName == 'VIDEO' && elt.dataset.autoplay != undefined) {
          elt.play()
        }
      })
      .on('exit', (elt) => {
        if (elt.tagName == 'VIDEO' && elt.dataset.autoplay != undefined) {
          elt.pause()
        }
      })
  }
}


window.addEventListener('load', () => {
  new App();
})